import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getTeacherEarnings } from "../../../../../store/actions/teacher";
import { toast } from "react-toastify";
import BalanceTable from "./BalanceTable";

const Earnings = () => {
  const dispatch = useDispatch();
  const [earnings, setEarnings] = useState([]);

  const fetchEarnings = React.useCallback(async () => {
    try {
      const data = await dispatch(getTeacherEarnings());
      if (data?.success) {
        setEarnings(data.data ?? []);
      } else {
        toast.error("Something went wrong. Please try again");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch earnings");
    }
  }, [dispatch]);

  useEffect(() => {
    fetchEarnings();
  }, [fetchEarnings]);

  const columns = [
    "Student",
    "Course",
    "Date",
    "Transaction ID",
    "Paid Amount",
    "Platform Fee (6%)",
    "Net Earning",
  ];

  return (
    <>
      {earnings.length > 0 ? (
        <BalanceTable columns={columns} data={earnings} type="Earnings" />
      ) : (
        <p>No Earnings</p>
      )}
    </>
  );
};

export default Earnings;
